import styled from 'styled-components';

export default styled.nav`
	.motif-header-menu-container {
		display: none;
	}
`;
